import { Resource as e } from "@coveo/platform-client";
//#region src/resources/OrganizationDefinitionResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/organizations";
	}
	getDefinition() {
		return this.api.get(super.buildPath(`${t.baseUrl}/${this.api.organizationId}/definition`));
	}
};
//#endregion
export { t as OrganizationDefinitionResource };

//# sourceMappingURL=OrganizationDefinitionResource.js.map